(function () {
	Vue.component('nominow-input-number', {
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			value: {
				default: null
			},
			defaultValue: {
				default: null
			},
			label: {
				type: String,
				required: true,
				default: 'Label'
			},
			name: {
				type: String,
				required: false
			},
			required: {
				type: Boolean,
				required: false
			},
			regex: {
				type: String,
				required: false
			},
			regexMessage: {
				type: String,
				required: false
			},
			css: {
				type: String,
				required: false
			},
			nomui: {
				type: Boolean,
				required: false
			}
		},
		template: `
		  <div class="field" :class="{'mui-textfield' : (!nomui)}">
		  <input type="number" :class="css" :name="name || label" :value="value" @blur="$emit('change', $event.target.value || defaultValue)" @input="$emit('change', $event.target.value || defaultValue)" :data-val="(required || regex ? 'true' : null)" :data-val-required="required ? 'Required' : ''" :data-val-regex="regexMessage" :data-val-regex-pattern="regex" />
		  <label>{{label}}</label>
		  </div>
		  `
	});
})();
